<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('groups') }}</span></li>
				</ul>
			</div>
		</div>

		<div id="roles_toolbar" class="toolbar">
			<button id="roles_table_toolbar_add" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">{{ $t('edit.company.groups') }}</a></li>
				<li><a tabindex="-1">{{ $t('remove.company.groups') }}</a></li>
			</ul>
		</div>
	</div>
</template>

<script>

import { CompanyGroupsManager } from '@/core/administration/CompanyGroupsManager'
import { USER_CONFIG } from 'actions/user'
import { Table, toggleSearchForm } from '@/core/support_gui_components/table/table'
import { getLocalizedMessage, removeTabindex, showMessageAlert } from '@/core/shared'
import { bindResetButton } from '@/core/input_controls/button/button'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'

export default {
	name: 'CompanyGroups',
	metaInfo () {
		return {
			title: this.$t('groups')
		}
	},
	props: [
		'id',
		'admin'
	],
	mounted () {
		let vm = this
		let tableColumns = [
			{
				'title': 'code',
				'columnName': 'code',
				'attribute': 'code'
			},
			{
				'title': 'name',
				'columnName': 'name',
				'attribute': 'name'
			},
			{
				'title': 'description',
				'columnName': 'description',
				'attribute': 'description'
			},
			{
				'title': 'global',
				'columnName': 'global_localized',
				'attribute': 'global'
			}
		]

		let companyId = this.id || this.$store.getters.getProfile.companyId

		window.manager = new CompanyGroupsManager()

		this.$store.dispatch(USER_CONFIG, 'groupsTable.tableState')
			.then((config) => {
				window.table = new Table('groupsTable', {
						selector: '#table',
						columns: tableColumns,
						dynamicLoading: true,
						contextMenu: '#context-menu',
						doubleClickMode: 'edit',
						sortingSupport: true,
						frozen: 'none',
						restoringSupport: true
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								if (item.companyId === null) {
									showMessageAlert('Global group can be edited only on administration page', 'warning')
									return
								}
								initUserGroupManager('edit', item, attribute)
							},
							2: function (item) {
								if (item.companyId === null) {
									showMessageAlert('Global group can be deleted only on administration page', 'warning')
									return
								}
								manager.initRemoveGroupManager(item)
							}
						},
						doubleClick: {
							'edit': function (item, table) {
								table.callbacks.contextMenu['1'](item, table.selectedAttribute)
							}
						}
					},
					function (data) {
						_.each(data, function (value) {
							value.global_localized = getLocalizedMessage(value.companyId === null)
						})
					})
				table.setSavedState(config)
				table.setDataUrl(window.urlContext + 'company/' + companyId + '/groups/load')
				table.setDataIDsUrl(window.urlContext + 'company/' + companyId + '/groups/ids')
				table.setDataSortUrl(window.urlContext + 'company/' + companyId + '/groups/sort')
				table.initTable()

				bindResetButton()
				removeTabindex()

				setToolbarMode(table.selectedItemsMode)
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG GroupsTable', error)
			})

		// toolbar buttons
		$('#table_toolbar_search').bind('click', toggleSearchForm)
		$('#roles_table_toolbar_add').click(function () {
			initUserGroupManager('create')
		})

		function initUserGroupManager (action, item, activeAttribute) {
			manager.setProperties({
				action: action,
				global: false,
				activeAttribute: activeAttribute,
				userGroup: item || {},
				companyId: companyId,
				saveButton: '#company_save-user-role',
				postSaveAction: function () {
					table.initTable()
				}
			})
			manager.openCreateGroupModal(action)
		}
	}
}
</script>

<style scoped>

</style>
